import { createContext, useContext } from "react";
import en from "@/i18n/en.json";
import tr from "@/i18n/tr.json";

export type Lang = "en" | "tr";
export type Dictionary = typeof en;

export const dictionaries: Record<Lang, Dictionary> = { en, tr };

export const I18nContext = createContext<Dictionary>(en);
export const useT = () => useContext(I18nContext);
